module.exports = __webpack_public_path__ + "static/media/equipamento.6abbc31d.png";